import EntityModel from '@/common/models/entity-model';
import shortid from 'shortid';

export default class CouponModel extends EntityModel {
    hydrate({
        redemptionCode = CouponModel.generateCouponCode(),
        discount = CouponModel.DefaultDiscount,
        restrictions = [],
        redemptionsCount = null,
        status = 'issued',
        description = null,
        issuedTime = null,
        expiredTime = null,
        createdTime = null,
        updatedTime = null,
    } = {}) {
        this.redemptionCode = redemptionCode;
        this.discount = {...discount};
        this.restrictions = restrictions.map(restriction => restriction);
        this.redemptionsCount = redemptionsCount;
        this.status = CouponModel.CouponStatus[status];
        this.description = description;
        this.issuedTime = issuedTime;
        this.expiredTime = expiredTime;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
    }

    static DiscountTypes = {
        fixed: 'fixed',
        percent: 'percent',
    };

    static RestrictionTypes = {
        discountsPerRedemption: 'discounts-per-redemption',
        minimumOrderAmount: 'minimum-order-amount',
        redemptionsPerCustomer: 'redemptions-per-customer',
        totalRedemptions: 'total-redemptions',
        restrictToInvoices: 'restrict-to-invoices',
        restrictToPlans: 'restrict-to-plans',
        restrictToSubscriptions: 'restrict-to-subscriptions',
        restrictToProducts: 'restrict-to-products',
        paidByTime: 'paid-by-time',
    };

    static DefaultDiscount = {
        type: CouponModel.DiscountTypes.fixed,
        amount: 0.00,
        value: 0,
        currency: 'USD',
    };

    static CouponStatus = {
        draft: 'draft',
        issued: 'issued',
        expired: 'expired',
    };

    static generateCouponCode() {
        return shortid.generate();
    }

    getPayload() {
        const payload = {
            redemptionCode: this.redemptionCode,
            discount: this.discount,
            restrictions: this.restrictions.map(restriction => restriction),
            redemptionsCount: Number(this.redemptionsCount),
            description: this.description,
            issuedTime: this.issuedTime,
            expiredTime: this.expiredTime,
            createdTime: this.createdTime,
            updatedTime: this.updatedTime,
        };
        if (payload.discount.amount !== undefined) {
            payload.discount.amount = Number(payload.discount.amount);
        }
        return payload;
    }
}
